import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import RmaForm from "./components/RmaForm";
import RmaStatusCheck from "./components/RmaStatusCheck";
import DCKUpdate from "./pages/DCKUpdate";

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100 text-gray-900 flex flex-col">
        <main className="flex-1 px-4 py-8">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/registracija" element={<PageShell><RmaForm /></PageShell>} />
            <Route path="/statusas" element={<PageShell><RmaStatusCheck /></PageShell>} />
            <Route path="/status/:rma" element={<PageShell><RmaStatusCheck /></PageShell>} />
            <Route path="/dck-atnaujinimas" element={<PageShell><DCKUpdate /></PageShell>} />
          </Routes>
        </main>

        <footer className="py-6 text-sm text-gray-500 text-center">
          &copy; {new Date().getFullYear()} GPSmeistras. Visos teisės saugomos.
        </footer>
      </div>
    </Router>
  );
}

function PageShell({ children }) {
  return (
    <div className="w-full max-w-6xl mx-auto">
      <Link
        to="/"
        className="inline-block mb-6 text-sm text-[#0056A0] underline hover:text-[#003b6f]"
      >
        ⬅ Grįžti į pradžią
      </Link>

      {children}
    </div>
  );
}

function HomePage() {
  return (
    <div className="w-full max-w-5xl mx-auto">
      <header className="text-center mb-10">
        <h1 className="text-3xl sm:text-4xl font-bold text-[#0056A0]">
          GPSmeistras Servisas
        </h1>
        <p className="text-gray-600 mt-3">
          Pasirinkite reikalingą veiksmą: registruoti servisą, patikrinti būseną arba atsisiųsti DCK atnaujinimą.
        </p>
      </header>

      <div className="grid gap-6 md:grid-cols-3">
        <HomeCard
          title="Serviso registracija"
          description="Užregistruokite gedimą, pridėkite įrenginio informaciją, aprašymą ir failus."
          buttonText="Registruoti servisą"
          to="/registracija"
        />

        <HomeCard
          title="RMA statusas"
          description="Patikrinkite remonto būseną pagal RMA kodą ir paskutinius 4 telefono numerio skaitmenis."
          buttonText="Tikrinti statusą"
          to="/statusas"
        />

        <HomeCard
          title="DCK atnaujinimas"
          description="Atsisiųskite DCK įrenginio atnaujinimo failą ir peržiūrėkite instrukciją."
          buttonText="DCK atnaujinimas"
          to="/dck-atnaujinimas"
        />
      </div>

      <section className="mt-10 bg-white rounded-2xl shadow p-5 sm:p-7">
        <div className="mb-5">
          <h2 className="text-2xl font-semibold text-gray-900">
            Kaip užregistruoti įrenginį servisui?
          </h2>
          <p className="text-gray-600 mt-2 text-sm sm:text-base">
            Peržiūrėkite trumpą video pamoką, kurioje žingsnis po žingsnio parodoma serviso registracija.
          </p>
        </div>

        <div className="aspect-video w-full overflow-hidden rounded-xl bg-black">
          <iframe
            className="h-full w-full"
            src="https://www.youtube.com/embed/9gQgzhIm7Bs"
            title="Kaip užregistruoti įrenginį GPSmeistras servisui"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </div>

        <a
          href="https://www.youtube.com/watch?v=9gQgzhIm7Bs"
          target="_blank"
          rel="noreferrer"
          className="mt-4 inline-block text-sm font-medium text-[#0056A0] underline hover:text-[#003b6f]"
        >
          Atidaryti video pamoką „YouTube“
        </a>
      </section>
    </div>
  );
}

function HomeCard({ title, description, buttonText, to }) {
  return (
    <div className="bg-white rounded-2xl shadow p-6 flex flex-col">
      <h2 className="text-xl font-semibold text-gray-900 mb-3">{title}</h2>
      <p className="text-gray-600 text-sm leading-6 flex-1">{description}</p>

      <Link
        to={to}
        className="mt-6 block text-center bg-[#0056A0] text-white font-semibold py-3 px-4 rounded-md hover:bg-[#004080] transition"
      >
        {buttonText}
      </Link>
    </div>
  );
}

export default App;